export default function initVideoLightbox() {
    const triggers = document.querySelectorAll('[data-video-lightbox]');
    if (!triggers.length) return;

    let overlay = null;
    let previouslyFocused = null;

    const close = () => {
        if (!overlay) return;
        overlay.remove();
        overlay = null;
        document.body.classList.remove('is-lightbox-open');
        document.removeEventListener('keydown', onKey);
        if (previouslyFocused) previouslyFocused.focus();
    };

    const onKey = (e) => {
        if (e.key === 'Escape') close();
    };

    // Normalise common YouTube / Vimeo URLs to their embed form so editors can
    // paste a watch URL, share URL, or embed URL interchangeably.
    const toEmbed = (url) => {
        try {
            const u = new URL(url);
            const host = u.hostname.replace(/^www\./, '');

            if (host === 'youtu.be') {
                const id = u.pathname.slice(1).split('/')[0];
                if (id) return `https://www.youtube.com/embed/${id}`;
            }

            if (host === 'youtube.com' || host.endsWith('.youtube.com')) {
                if (u.pathname === '/watch' && u.searchParams.get('v')) {
                    return `https://www.youtube.com/embed/${u.searchParams.get('v')}`;
                }
                const m = u.pathname.match(/^\/shorts\/([^/]+)/);
                if (m) return `https://www.youtube.com/embed/${m[1]}`;
            }

            if (host === 'vimeo.com') {
                const id = u.pathname.slice(1).split('/')[0];
                if (id && /^\d+$/.test(id)) return `https://player.vimeo.com/video/${id}`;
            }
        } catch (_) { /* fall through */ }
        return url;
    };

    const withAutoplay = (url) => {
        const embed = toEmbed(url);
        try {
            const u = new URL(embed);
            // YouTube uses autoplay=1; Wistia and many others honour autoPlay=true.
            if (u.hostname.includes('youtube.com')) u.searchParams.set('autoplay', '1');
            else u.searchParams.set('autoPlay', 'true');
            return u.toString();
        } catch (_) {
            return embed + (embed.includes('?') ? '&' : '?') + 'autoPlay=true';
        }
    };

    const open = (url) => {
        if (overlay) return;
        previouslyFocused = document.activeElement;

        overlay = document.createElement('div');
        overlay.className = 'video-lightbox';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-label', 'Video player');
        overlay.innerHTML = `
            <div class="video-lightbox__backdrop" data-close></div>
            <div class="video-lightbox__dialog">
                <button type="button" class="video-lightbox__close" aria-label="Close video" data-close>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
                <div class="video-lightbox__frame">
                    <iframe
                        src="${withAutoplay(url)}"
                        title="Video player"
                        frameborder="0"
                        allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
                        allowfullscreen></iframe>
                </div>
            </div>
        `;
        document.body.appendChild(overlay);
        document.body.classList.add('is-lightbox-open');

        overlay.addEventListener('click', (e) => {
            if (e.target.closest('[data-close]')) close();
        });

        const closeBtn = overlay.querySelector('.video-lightbox__close');
        if (closeBtn) closeBtn.focus();

        document.addEventListener('keydown', onKey);
    };

    triggers.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            const url = el.getAttribute('data-video-lightbox');
            if (url) open(url);
        });
    });
}
